import { connect } from 'react-redux'
import { HomeComponent } from './HomeComponent'
import { fetchHomePageData } from 'shared/store/homepage'
import type { FetchOrdersParams } from 'shared/store/ecommerce/order'
import { fetchOrders } from 'shared/store/ecommerce/order'
import type { Dispatch } from 'redux'
import type { RootState } from 'shared/store/reducers'
import { getDisplayableOrders } from 'shared/utils/ecommerce/utils'
import { featureCodes } from 'shared/utils'
import { isMobile, isTablet } from 'react-device-detect'

const mapStateToProps = (state: RootState) => {
    const { cacOrders } = state.ecommerceOrderState
    const displayableOrdersNumber = getDisplayableOrders(
        cacOrders,
        !isMobile && !isTablet
    ).filter(order => !order.discarded).length
    const {
        marketingAnimations,
        nearbyRestaurants,
        error,
        dataLoaded
    } = state.homePageState
    const { authenticated } = state.userState
    const { available } = state.featuresState
    return {
        marketingAnimations,
        nearbyRestaurants,
        error,
        dataLoaded,
        authenticated,
        displayableOrdersNumber,
        tableOrderEnabled: available.includes(featureCodes.TABLE_ORDER)
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    fetchPageData: () => d(fetchHomePageData()),
    fetchOrders: (fetchOrdersParams?: FetchOrdersParams) =>
        d(fetchOrders(fetchOrdersParams))
})

const Home = connect(mapStateToProps, mapDispatchToProps)(HomeComponent)

export { Home }
